module.exports = __webpack_public_path__ + "static/media/AirTractor-Barriga.f418a5a8.png";